<script>
import { ref } from 'vue';

export default {
    name: 'InboxView',
    data() {
        return {
            filters: '',
            something: '',
            items: [],
            filteredItems: [],
            isDeleting: false,
            deletingItemId: null,
            showConfirmDialog: false,
            itemToDelete: null
        }
    },
    created() {
        fetch(`${process.env.VUE_APP_BASE_URL}/get-chats`, {
            headers: {
                'Token': `Bearer ${this.$cookies.get('pb_token')}`,
                'User': this.$cookies.get('pb_user'),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                var chat_objects = json;
                // set each item to chat.chat_id and chat.date_created
                this.items = chat_objects.map(chat => {
                    console.log(chat)
                    return {
                        title: chat.title,
                        date: chat.date,
                        link: `/paper/${encodeURIComponent(chat.chat_id)}?doc_id=${chat.document_id}`,
                        chat_session_id: chat.chat_id
                    }
                })
                this.filteredItems = [...this.items];
            })
            .catch(error => {
                console.error('Error:', error); // Log any errors
            });

    },
    methods: {
        confirmDelete(chat_session_id) {
            this.showConfirmDialog = true;
            this.itemToDelete = chat_session_id;
        },
        cancelDelete() {
            this.showConfirmDialog = false;
            this.itemToDelete = null;
        },
        deleteChatSession() {
            if (!this.itemToDelete) return;

            this.isDeleting = true;
            this.deletingItemId = this.itemToDelete;
            console.log(JSON.stringify({ chat_session_id: this.itemToDelete }))
            fetch(`${process.env.VUE_APP_BASE_URL}/delete-chat-session`, {
                method: 'POST',
                headers: {
                    'Token': `Bearer ${this.$cookies.get('pb_token')}`,
                    'User': this.$cookies.get('pb_user'),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ chat_session_id: this.itemToDelete })
            })
                .then(response => response.json())
                .then(json => {
                    console.log(json)
                    // Remove the deleted item from the lists
                    this.items = this.items.filter(item => item.chat_session_id !== this.itemToDelete);
                    this.filteredItems = this.filteredItems.filter(item => item.chat_session_id !== this.itemToDelete);
                    this.isDeleting = false;
                    this.deletingItemId = null;
                    this.showConfirmDialog = false;
                    this.itemToDelete = null;
                })
                .catch(error => {
                    console.error('Error:', error); // Log any errors
                    this.isDeleting = false;
                    this.deletingItemId = null;
                    this.showConfirmDialog = false;
                    this.itemToDelete = null;
                });
        }
    },


    watch: {
        filters(newValue, oldvalue) {

            if (newValue === '' || newValue === null) {
                this.filteredItems = this.items;
            } else {
                this.filteredItems = this.items.filter(item => {

                    return item["title"].toLowerCase().includes(newValue.toLowerCase())
                }
                )
            }
        }
    }
}


</script>

<template>
    <v-container class="py-5 px-3">
        <v-autocomplete class="sticky text-white" label="Search Chats" :items="items" variant="underlined"
            style="size: 100px;" v-model="filters"></v-autocomplete>
        <v-row class="overflow-y-scroll max-h-[80vh]">
            <v-col cols="12">
                <v-card>
                    <!-- Create a table header with the ability to filter by label and date -->

                    <v-list lines="two">


                        <template v-for="item in filteredItems" :key="item.title" >
                            <v-list-item class="hover:bg-black hover:text-white hover:bold border-b border-black">
                                <!-- <template v-slot:append>
                                </template> -->
                                
                                <router-link :to=item.link>
                                    <v-list-item-title 
                                    :title=item.title
                                    class="text-lg font-medium"
                                    >
                                    {{ item.title }}
                                </v-list-item-title>
                            </router-link>
                            <div class="flex items-center">
                                <span class="text-gray-400 mr-4">{{ item.date }}</span>
                                <button @click="confirmDelete(item.chat_session_id)"
                                    class="cursor-pointer hover:scale-150 transition-all duration-200">
                                    <i class="pi pi-trash"></i>
                                </button>
                            </div>
                        </v-list-item>

                            <v-divider></v-divider>
                        </template>

                    </v-list>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <!-- Confirmation dialog for deletion -->
    <v-dialog v-model="showConfirmDialog" persistent max-width="300">
        <v-card>
            <v-card-title class="headline">Confirm Deletion</v-card-title>
            <v-card-text>Are you sure you want to delete this chat session?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="cancelDelete">Cancel</v-btn>
                <v-btn color="red darken-1" text @click="deleteChatSession">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Popup dialog for deletion process -->
    <v-dialog v-model="isDeleting" persistent max-width="300">
        <v-card>
            <v-card-text>
                Deleting chat session...
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
